import React from 'react';
import { Link } from 'react-router-dom';
import {history} from '../routers/AppRouter';
import ScrollArea from 'react-scrollbar';
import PageAnimation from '../components/PageTransitions';

class HomePage extends React.Component{

  handelScrollTo = () =>{
    this.refs.scrollArea.scrollBottom();
  }
render(){
  return(
    <PageAnimation frompage={history.location.state.prevPath} topage={history.location.pathname} animP="/">
      <ScrollArea
            ref="scrollArea" 
            smoothScrolling={true}
            className="homePage"
            speed={800}
            onScroll={(value) => {
                if(value.topPosition <= 100 || value.topPosition === undefined ){
                  document.querySelector(".logo").classList.add("home");
                } else{
                  document.querySelector(".logo").classList.remove("home");
                }
            }}
            verticalContainerStyle={{background:"#cccccc"}}
            verticalScrollbarStyle={{background:"#ffffff"}}
            horizontal={false}
            >
        <div className="intro">
        <div className="scrollExploreMore">
          <p>Scroll to explore more</p>
          <span className="button socialIcon" onClick={this.handelScrollTo}><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"></span></span>
        </div>
        </div>
        <div ref="whereToGo" className="whereToGo v-center">
          <div className="bContainer">
            <div className="col-in-6">
              <h1><Link to={{pathname: 'about', state: { prevPath: location.pathname }}}><span className="icon-arrow-left"></span> About</Link></h1>
            </div>
            <div className="col-in-6">
              <h1><Link to={{pathname: 'work', state: { prevPath: location.pathname }}}>Work <span className="icon-arrow-right"></span></Link></h1>
            </div>
            {/*<div className="col-xs-12">
              <div className="sortlist">
                <a href="https://www.sortlist.com/agency/bni-bright-new-ideas?ref=review-widget-1" target="_blank"> <img  alt="Click here to view the agency's profile on Sortlist" src="https://www.sortlist.com/widget/bni-bright-new-ideas/review?ref=review-widget-1"/> </a>
              </div>  
          </div>*/}
          </div>
        </div>  
      </ScrollArea>
      </PageAnimation>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/HomePage.js